import BaseStore from '@src/utils/store/base-store';
import { useEffect } from 'react';
import { jumpPage } from '@src/utils/common-util';
import useMount from '@src/utils/hooks/use-mount';
import NaviBarStore from '@src/business-components/navibar/store';

class MainStore extends BaseStore {
  naviBarStore = new NaviBarStore({
    MainStore: this
  });

  more(url) {
    // if (!IS_DEV_ENV) {
    //   const link = `${url}.html`;
    //   jumpPage(link, '#/');
    // } else {
      this?.redirect(`/${url}`);
    // }
  }

  use() {
    super.use();
    useMount(async () => {
      this.naviBarStore.currentIndex = 0;
    });
  }
}

export default MainStore;
